// extracted by mini-css-extract-plugin
export var drawerContent = "_32-0";
export var valueBlock = "_32-1";
export var valueBlockFrom = "_32-2 _32-1";
export var valueBlockTo = "_32-3 _32-1";